import React, { useEffect, useState } from 'react';
import s from '../styles/CategoryTree.module.css'; // создайте этот модуль для стилизации
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle} from '@fortawesome/free-solid-svg-icons';

const MAX_CHECKBOXES = 10;

const CategoryTree = ({ projectHref, onClose }) => {

  const [categories, setCategories] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [expandedIds, setExpandedIds] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetch('/api/categories/categories')
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
        const rootIds = new Set(data.filter(c => c.parent_id === 0).map(c => c.id));
        setExpandedIds(rootIds);
      })
      .catch(() => setMessage('Ошибка загрузки категорий'))
      .finally(() => setLoading(false));

    return () => setExpandedIds(new Set()); // сброс раскрытия при закрытии модалки
  }, []);

  const toggleCheckbox = (id, checked) => {
    setSelectedIds((prev) => {
      if (checked) {
        if (prev.length >= MAX_CHECKBOXES) return prev;
        return [...prev, id];
      } else {
        return prev.filter((item) => item !== id);
      }
    });
  };

  const toggleExpand = (id) => {
    setExpandedIds((prev) => {
      const newSet = new Set(prev);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);
      return newSet;
    });
  };

  const buildTree = (parentId) => {
    return categories
      .filter((c) => c.parent_id === parentId)
      .map((c) => {
        const children = categories.some(child => child.parent_id === c.id);
        const isExpanded = expandedIds.has(c.id);

        return (
          <li key={c.id}>
            <div className={s.categoryRow}>
              {children && (
                <span
                  className={s.toggleArrow}
                  onClick={() => toggleExpand(c.id)}
                >
                  {isExpanded ? '▼' : '▶'}
                </span>
              )}
              {c.category_id !== null && (
                <input
                  type="checkbox"
                  checked={selectedIds.includes(c.id)}
                  onChange={(e) => toggleCheckbox(c.id, e.target.checked)}
                />
              )}
              <span>{c.name}</span>
            </div>
            {isExpanded && <ul>{buildTree(c.id)}</ul>}
          </li>
        );
      });
  };

  const handleSubmit = async () => {
    if (selectedIds.length === 0) {
      setMessage('❗ Выберите хотя бы одну категорию.');
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        href: projectHref,
        category_id: selectedIds.map(String),
      };

      const res = await fetch("/templatetogoogle", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (res.ok && result.success) {
        setMessage("⏳ Обработка запущена. Уведомление придёт в Telegram в течение 1–3 минут.");
        setTimeout(() => onClose(), 1500);
      } else {
        setMessage(result.message || "❌ Ошибка при запуске.");
      }
    } catch (err) {
      setMessage("❌ Ошибка отправки запроса.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={s.modalOverlay}>
      <div className={s.modal}>
        <h2 className={s.h2_header}>Выберите категорию</h2>
        <button className={s.close} onClick={onClose}> <FontAwesomeIcon icon={faTimesCircle} /></button>
        {loading ? (
          <p>Загрузка...</p>
        ) : (
          <ul className={s.tree}>{buildTree(0)}</ul>
        )}
        <div className={s.submit_button_div}>
           <button
          className={s.submit}
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? 'Обработка...' : 'Добавить шаблон'}
        </button> 
        </div>
        
        {message && <div className={s.message}>{message}</div>}
      </div>
    </div>
  );
};

export default CategoryTree;
